import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {RefundApiService, RefundRequest} from '@npck/af-frontend-api';

@Component({
    selector: 'af-refund-preview-document',
    standalone: false,
    templateUrl: './refund-preview-resolution-dialog.component.html',
    styleUrl: './refund-preview-resolution-dialog.component.scss',
})
export class RefundPreviewResolutionDialogComponent {
    src: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: PreviewResolutionDialogData,
        public dialogRef: MatDialogRef<RefundPreviewResolutionDialogComponent>,
        private refundApiService: RefundApiService,
    ) {
        this.refundApiService.previewResolutionForm(dialogData.refundRequest)
            .subscribe(response => {
                this.src = URL.createObjectURL(response);
            });
    }
}

export interface PreviewResolutionDialogData {
    refundRequest: RefundRequest;
}
